import React from 'react';
import { Card, CardBody, CardHeader, Col, Table } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { CartProducts } from '../../../Data/Widgets/general/index';
import { ProductsCart } from '../../../Constant';

const ProductCart = () => {
  return (
    <>
      <Col xl='6' className='xl-50 box-col-6'>
        <Card className='user-status'>
          <CardHeader className='pb-0'>
            <H5>{ProductsCart}</H5>
          </CardHeader>
          <CardBody>
            <Table responsive borderless>
              <thead>
                <tr>
                  {CartProducts.head.map((item, i, arr) => (
                    <th key={i} scope='col' className={i === arr.length - 1 ? 'text-end' : ''}>
                      {item}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {CartProducts.body.map((data) => (
                  <tr key={data.id}>
                    <td>{data.details}</td>
                    <td>{data.qty}</td>
                    <td className={`font-${data.statusColor}`}>{data.price}</td>
                    <td className='text-end'>
                      <span className={`badge ${data.className}`}>{data.status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};
export default ProductCart;
